<template>
  <div id="fields-white-mark">
    <div class="row is-white-mark" v-if="isLoaded">
        <b-form-checkbox v-model="isWhiteMarking" name="switch" switch>
          <b class="title">{{ $t('fieldsWhiteMark.switch') }}</b>
        </b-form-checkbox>
    </div>

    <div class="row is-white-mark" v-if="alert.delete.show">
      <div class="col-12">
        <b-alert dismissible :show="alert.delete.show" :variant="alert.delete.variant">
          {{ $t(`fieldsWhiteMark.alert.delete.${alert.delete.variant}`) }}
        </b-alert>
      </div>
    </div>

    <div class="row is-white-mark" v-if="isWhiteMarking">
       <span class="title">{{ $t('fieldsWhiteMark.infos') }}</span>
    </div>

    <div class="row is-white-mark" v-if="isWhiteMarking">
      <div class="col-6 fields" v-for="info in infoLabels">
        <text-input :key="info.key"
                    :label="`fieldsWhiteMark.info.${info.key}`"
                    :required="false"
                    :name="info.key"
                    :ref="info.key"
                    inline-display
                    v-model="infos[info.key]"
        />
      </div>
    </div>

     <div class="row" v-if="isWhiteMarking">
         <div class="col-10">
           <b-alert dismissible :show="alert.add.show" :variant="alert.add.variant">
             {{ $t(`fieldsWhiteMark.alert.add.${alert.add.variant}`) }}
           </b-alert>
         </div>

       <div class="text-right col-2">
         <button class="btn orange-white" @click="onSubmitWhiteMark" :disabled="!isComplete">
           {{ $t('form.submit') }}
         </button>
         <button class="btn orange-white" :title="$t('_delete')" @click="onDelete">
           <fa fa-class="trash-alt" />
         </button>
       </div>
     </div>
  </div>
</template>

<script>

import CommonApi from '@/api/commonApi'
import textInput from '@/components/frontoffice/form/baseInput/text'
import fa from '@/components/global/icon/fontAwesome'
import FormSubmitter from '@/api/formSubmitter'

const api = new CommonApi()

export default {
  components: {
    fa,
    textInput
  },

  data () {
    return {
      id: null,
      companyId: null,
      infoLabels: [
        { key: 'phoneNumber', value: null },
        { key: 'emergencyContact', value: null },
        { key: 'mail', value: null },
        { key: 'openingHours', value: null }
      ],
      isWhiteMarking: false,
      isLoaded: true,
      isFetching: false,
      infos: {
        phoneNumber: null,
        emergencyContact: null,
        mail: null,
        openingHours: null
      },
      alert: {
        add: {
          show: false,
          variant: 'success'
        },
        delete: {
          show: false,
          variant: 'success'
        }
      }
    }
  },

  created () {
    this.companyId = this.$route.params.id

    api.getFieldsWhiteMark(this.companyId)
      .then(response => {
        let fieldsWhiteMark = response.data.data.fieldsWhiteMark

        this.isWhiteMarking = response.data.data.isWhiteMarking

        if (fieldsWhiteMark) {
          this.id = fieldsWhiteMark.id
          this.infos.phoneNumber = fieldsWhiteMark.phone_number
          this.infos.emergencyContact = fieldsWhiteMark.emergency_contact
          this.infos.mail = fieldsWhiteMark.mail
          this.infos.openingHours = fieldsWhiteMark.opening_hours
        }
      })
  },

  methods: {
    onSubmitWhiteMark () {
      let submitter = new FormSubmitter('fields_white_mark')
      submitter.submitRequest(
        this.companyId,
        {
          id: this.id,
          infos: {
            phoneNumber: this.infos.phoneNumber,
            emergencyContact: this.infos.emergencyContact,
            mail: this.infos.mail,
            openingHours: this.infos.openingHours,
            isWhiteMarking: this.isWhiteMarking
          }
        }
      ).then(response => {
        this.alert.add.show = true
        if (this.alert.delete.show) {
          this.alert.delete.show = false
        }
        if (response.data.success) {
          this.id = response.data.data.id
          this.alert.add.variant = 'success'
        } else {
          this.alert.add.variant = 'danger'
        }
      })
    },

    onDelete () {
      api.deleteFieldsWhiteMark(this.companyId)
        .then(response => {
          this.alert.delete.show = true
          if (this.alert.add.show) {
            this.alert.add.show = false
          }
          if (response.data.success) {
            this.isWhiteMarking = false
            this.infos = {
              phoneNumber: null,
              emergencyContact: null,
              mail: null,
              openingHours: null
            }
            this.alert.delete.variant = 'success'
          } else {
            this.alert.delete.variant = 'danger'
          }
        })
    }
  },

  computed: {
    isComplete () {
      return this.infos.phoneNumber && this.infos.emergencyContact && this.infos.mail && this.infos.openingHours
    }
  }
}
</script>

<style lang="scss">
#fields-white-mark {
  .is-white-mark {
    margin: 1rem;

    .title {
      font-size: 1.1rem;
      font-weight: bold;
      cursor: pointer;
    }

    .fields{
      margin-bottom: 10px;
    }
  }

  .alert{
    margin-top: 0;
  }

}
</style>
